import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';

// Browser polyfills for FormData, File API, and other modern features
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './index.css';
import 'chart.js/auto';
import './types/mui-button-variants';
import './types/mui-chip-variants';
import './types/mui-card-variants';
import * as Sentry from '@sentry/react';
import App from './App';
//import reportWebVitals from "./utils/reportWebVitals";
import { ThemeProvider } from './contexts/ThemeContext';

//translations import
import './i18n';

//Sentry
Sentry.init({
  dsn: import.meta.env.REACT_APP_SENTRY_DSN,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/api\.jst\.scifree\.se/,
    /^https:\/\/api\.jstscifree\.com/,
  ],
  integrations: [
    Sentry.browserTracingIntegration({
      // Exclude Zendesk requests — the widget makes many internal calls that
      // cause Sentry to instrument them, blocking Chrome's network stack and
      // causing ~30s delay + CPU spike when opening the help widget.
      shouldCreateSpanForRequest: (url) => {
        if (url.includes('zdassets.com')) return false;
        if (url.includes('zendesk.com')) return false;
        return true;
      },
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
